<template>
  <master-layout>
  <div></div>
</master-layout>
</template>

<script>
export default {
  name: "ResourcesPage",
  async ionViewWillEnter() {
    this.$router.push("/resources/sessions");
  }
};
</script>
